<template>
  <component :is="containerTag" class="title please_wait_txt">
    {{ $_translations.value[text] }}
    <span id="wait-custom">{{ dotText }}</span>
  </component>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

defineProps({
  containerTag: {
    type: String,
    default: 'h3',
  },
  text: {
    type: String,
    default: '',
  },
});

const dotText = ref('');
const intervalConfiguration = ref({ id: null, delay: 400 });

onMounted(() => {
  intervalConfiguration.value.id = setInterval(() => {
    if (dotText.value.length > 2) {
      dotText.value = '';
    } else {
      dotText.value += '.';
    }
  }, intervalConfiguration.value.delay);
});

onBeforeUnmount(() => {
  clearInterval(intervalConfiguration.value.id);
});
</script>
